import { Button, Card, InputNumber, Radio } from "antd";
import React from "react";



const PaymentSettings = (props) => {
    const {onUpdateValue, settingsList, isUpdateAllowValue} = props;

    return <Card className="payment-card">
    <div className="payment_content">
        <div className="card-heading">
          Gratuity Settings
        </div>
        <div className="content_item flex-wrap">
            <label className="info_label">Allow Cash Payment:</label>
            <Radio.Group value={settingsList?.pos_allow_cash_payment} onChange={(e)=>{isUpdateAllowValue(e, 'pos_allow_cash_payment')}}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
            </Radio.Group>
        </div>
        <div className="content_item flex-wrap">
            <label className="info_label">Allow Tipping in Terminal:</label>
            <Radio.Group value={settingsList?.pos_allow_tipping_in_terminal} onChange={(e)=>{isUpdateAllowValue(e, 'pos_allow_tipping_in_terminal')}}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
            </Radio.Group>
        </div>
        <div className="grativity_section">
          <div className="grativity_item flex-wrap">
              <label className="info_label">Enable Gratuity:</label>
              <Radio.Group value={settingsList?.pos_allow_tips_for_parties} onChange={(e)=>{isUpdateAllowValue(e, 'pos_allow_tips_for_parties')}}>
                  <Radio value={true}>Yes</Radio>
                  <Radio value={false}>No</Radio>
              </Radio.Group>
          </div>
          <div className="flex flex-wrap">
            <div className="grativity_item flex-wrap">
              <label className="info_label">Apply Gratuity on party greater than:</label>
              <InputNumber disabled={!settingsList?.pos_allow_tips_for_parties} value={settingsList.pos_tips_for_parties_greater_than} onChange={(e)=>{onUpdateValue(e, 'pos_tips_for_parties_greater_than')}}/>
            </div>
            <div style={{ marginLeft: 40 }} className="grativity_item1 flex-wrap">
              <label className="gratuity_label">Gratuity Amount: </label>
              <InputNumber addonAfter="%"
              disabled={!settingsList?.pos_allow_tips_for_parties} value={settingsList.pos_tips_for_parties_amount} onChange={(e)=>{onUpdateValue(e, 'pos_tips_for_parties_amount')}}/>
            </div>
          </div>
        </div>
    </div>
  </Card>
};
export default PaymentSettings;